export interface InvoiceAdjustmentUpsertDto {
  AdjustmentId: number;
  AdjustmentAmount: number;
  AdjustmentDate: Date;
  ApplyDate: Date;
  Descr: string;
  ProfileId: number;
  ReferenceNum: string;
  InvoiceNum: number;
  InvoiceLineItemId: number;
  PaymentId: number;
  UnappliedPaymentId: number;
  AdjustmentTypeId: number;
  AdjustmentType: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  GlAccount: string;
  Posted: boolean;
  DatePosted: Date;
  Batch_Creation: string;
  Batch_Posting: string;
  PostedBy: string;
  DeleteAdjustment: boolean;
  Dirty: boolean;
  RelatedLineItemId: number;
}
export function initializedInvoiceAdjustmentUpsertDto() {
  const today = new Date();
  return {
    AdjustmentAmount: 0,
    AdjustmentDate: today,
    ApplyDate: today,
  } as InvoiceAdjustmentUpsertDto;
}
